export default "__VITE_ASSET__C1kaLd7S__"